import { IComponentOptions } from "angular";
import { FilterSiteController } from "./filter.site.controller";

angular
    .module("thor.loki.filter.site.component", [])
    .component("lokiFilterSite", <IComponentOptions>{
        bindings: {
            filterParams: "=",
            isIe: "<",
            context: "<"
        },
        controller: FilterSiteController,
        template: require("./filter.site.html")
    });
